<div class="flex flex-col justify-center py-[30px] px-4 lg:px-8 relative">
  <button class="absolute top-[20px] right-[20px] z-10 w-[16px] h-[16px] flex items-center justify-center outline-none"
          mat-dialog-close>
    <mat-icon class="text-[#9F9F9F] !w-[16px] !h-[16px] !text-[16px]" [svgIcon]="'close'"></mat-icon>
  </button>
  <div class="flex flex-col justify-center mx-auto items-center max-w-[80px] max-h-[80px]">
    <img src="./assets/images/access-denied.png" alt="access-denied">
  </div>
  <span class="leading-[1.4] font-bold text-[20px] text-[#022D35] text-center mt-3">
    Your current role does not grant <br> permission to view this page.
  </span>
  <div class="flex flex-col items-center mt-[20px]">
    <span class="bg-[#EAEAEA] flex justify-center items-center min-h-5 min-w-[148px] rounded-[60px] text-[14px] text-[#022D35] px-3 py-3">
      <mat-icon svgIcon="vector-lock-icon" class="!w-full !h-auto max-w-[9px] max-h-[13px] text-[#C93535] mr-1"></mat-icon>
      <span class="text-center leading-[1.2] whitespace-nowrap">
        Your current role does not grant permission <br> to view this page.
      </span>
    </span>
    <span class="text-center text-[14px] leading-[1.6] text-[#022D35] mt-3">
      Please contact your organization administrator <br> if you believe this is an error.
    </span>
  </div>
</div>

